module.exports = __webpack_public_path__ + "img/front.80cec052.webp";